window.addEventListener("load", window.togContentHeight, false);

function is(type, obj) {
    let clas = Object.prototype.toString.call(obj).slice(8, -1);
    return obj !== undefined && obj !== null && clas === type;
}

window.togContentHeight = function (e, goTop) {
    let target = parent.postMessage ? parent : (parent.document.postMessage ? parent.document : undefined);
    if (typeof goTop == 'undefined') goTop = true;

    if (typeof target != "undefined") {
        if (is("String",e)) {
            if (e == "") {
                target.postMessage({
                    command: 'height',
                    height: Math.max(document.body.scrollHeight,document.body.offsetHeight),
                    go_top: goTop
                }, "*");
            } else {
                target.postMessage({
                    command: 'height',
                    height: e,
                    go_top: goTop
                }, "*");
            }
        } else if (document.body.scrollHeight) {
            target.postMessage({
                command: 'height',
                height: Math.max(document.body.scrollHeight,document.body.offsetHeight),
                go_top: goTop
            }, "*");
        }
    }
}

window.togScrollTo = function (x, y, smooth) {
    let target = parent.postMessage ? parent : (parent.document.postMessage ? parent.document : undefined);
    if (smooth === undefined) smooth = false;

    target.postMessage({
        command: 'scroll',
        x: x,
        y: y,
        smooth: smooth,
    }, "*");
}
